
  <div class="rec-container ">
    <h2>Select Unindexed Land Records</h2>
    <form (ngSubmit)="onSubmit($event)" #f="ngForm">

      <div class="index-container">
        <app-select-index></app-select-index>
      </div>
      <div class="space">

      </div>
      <div class="help-text">
        <br />
        <label>{{selectindexChild.helpText}}</label>
        <br />
      </div>
      <!--<div class="index-container" *ngIf="selectindexChild.indexId<3">
    <app-book-page></app-book-page>
  </div>-->
      <div class="entry-container" *ngIf="selectindexChild.indexId<3">
        <label for="book">{{selectindexChild.header}} <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
        <input type="text" id="bk" name="nbr" maxlength="10" [(ngModel)]="nbr" >
      </div>
      <button class="btn btn-default" type="submit">
        DISPLAY
      </button>
    </form>
  </div>



